// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import { User } from '@fc-core';
import {
  logOutCurrentUserAction,
  retrieveCurrentUser,
  retrieveCurrentUserSuccess,
} from '../actions';

export type State = { user: User; loading: boolean };

export const initialState: State = <State>{
  user: null,
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(retrieveCurrentUser, (state) => ({
    ...state,
    loading: true,
  })),
  on(retrieveCurrentUserSuccess, (state, action) => ({
    ...state,
    user: action.user,
    loading: false,
  })),
  on(logOutCurrentUserAction, () => initialState),
);

export const getCurrentUser = (state: State) => state.user;
export const getCurrentUserLoading = (state: State) => state.loading;
